import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 12 13",
  "content": "<symbol viewBox=\"0 0 12 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"cross\"><path d=\"M10.607 12.157 0 1.55.707.843 11.314 11.45l-.707.707Z\" /><path d=\"M0 11.45 10.606.843l.707.707L.707 12.157 0 11.45Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol